module.exports = __webpack_public_path__ + "image/news-arrow.1782790484418.png";